import React from 'react';
import NotesSidebar from '../Notes/NotesSidebar';
import CalendarSidebar from '../Calendar/CalendarSidebar';
import BreakReminderSidebar from '../BreakReminder/BreakReminderSidebar';
import ChatSidebar from '../Chat/ChatSidebar';
import SettingsSidebar from '../Settings/SettingsSidebar';
import AdBanner from '../Advertisement/AdBanner';
import { useAdmin } from '../../contexts/AdminContext';
import { useMembership } from '../../hooks/useMembership';

const Sidebar = ({ activeSection }) => {
  const { isImpersonating, getActiveUserId } = useAdmin();
  const { isFreeUser } = useMembership();
  const activeUserId = getActiveUserId();

  const renderSidebar = () => {
    switch (activeSection) {
      case 'notes':
        return <NotesSidebar />;
      case 'calendar':
        return <CalendarSidebar />;
      case 'break-reminder':
        return <BreakReminderSidebar />;
      case 'chat':
        return <ChatSidebar />;
      case 'settings':
        return <SettingsSidebar />;
      default:
        return <NotesSidebar />;
    }
  };

  return (
    <div className="w-80 bg-white dark:bg-[var(--color-bg-base)] border-r border-slate-200 dark:border-white/5 flex flex-col shrink-0">
      {renderSidebar()}
    </div>
  );
};

export default Sidebar;

